import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n } from "@/hooks/useI18n";
import { DayAxis, axisDayCount, dayKeyFromIndex } from "../models/day-axis";

interface DaySelectProps {
  /** Asse in modalità template: il selettore ragiona per posizione, non per data. */
  axis: DayAxis;
  /** Giorno selezionato, come chiave (`D3`). */
  value?: string | null;
  onSelect: (dayKey: string) => void;
  placeholder?: string;
  hasError?: boolean;
  disabled?: boolean;
  /** Primo giorno selezionabile (es. il check-out non può precedere il check-in). */
  minIndex?: number;
  /**
   * Giorni oltre la durata del template selezionabili comunque: serve al check-out,
   * che cade tipicamente il giorno dopo l'ultima notte.
   */
  extraDays?: number;
}

/**
 * Selettore di giorno per gli itinerari senza date (template).
 * È l'equivalente del DatePicker sugli itinerari collegati a una travel request.
 */
export const DaySelect = ({
  axis,
  value,
  onSelect,
  placeholder,
  hasError = false,
  disabled = false,
  minIndex = 1,
  extraDays = 0,
}: DaySelectProps) => {
  const { t } = useI18n();

  const lastIndex = axisDayCount(axis) + extraDays;
  const options = Array.from({ length: Math.max(lastIndex - minIndex + 1, 0) }, (_, i) => minIndex + i);

  return (
    <Select
      value={value || undefined}
      onValueChange={onSelect}
      disabled={disabled}
    >
      <SelectTrigger hasError={hasError}>
        <SelectValue placeholder={placeholder || t('builder.selectDay')} />
      </SelectTrigger>
      <SelectContent>
        {options.map(index => (
          <SelectItem key={index} value={dayKeyFromIndex(axis, index)}>
            {t('builder.dayNumber', { number: index })}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
